<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mb-0 float-start" style="padding-left: 25px">
                    {{ $t("fulfillment_edit") }}
                  </h6>
                   
                </div>

                <div class="card-body">
                 
                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >                    

                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('company_group_id')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        
                        <v-select
                            :options="fetchCompanyGroup"
                            v-model="company_group"
                            label="company_group_description"
                            return-object
                            @search="asyncSearchCompanyGroup"
                          ></v-select>



                        <div v-if="errors.company_group_id">
                          <div
                            v-for="error in errors.company_group_id"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
 
  
         
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('fulfillment_code')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="fulfillment_code"
                          :placeholder="$t('fulfillment_code')"
                          v-model="forms.fulfillment_code"
                          required
                        />
                        <div v-if="errors.fulfillment_code">
                          <div
                            v-for="error in errors.fulfillment_code"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('fulfillment_description')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="fulfillment_description"
                          :placeholder="$t('fulfillment_description')"
                          v-model="forms.fulfillment_description"
                          required
                        />
                        <div v-if="errors.fulfillment_description">
                          <div
                            v-for="error in errors.fulfillment_description"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('area_palet')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="area_palet"
                        :placeholder="$t('area_palet')"
                        v-model="forms.area_palet"
                        required
                      />
                      <div v-if="errors.area_palet">
                        <div
                          v-for="error in errors.area_palet"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('mover_area')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="mover_area"
                        :placeholder="$t('mover_area')"
                        v-model="forms.mover_area"
                        required
                      />
                      <div v-if="errors.mover_area">
                        <div
                          v-for="error in errors.mover_area"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('total_area')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="total_area"
                        :placeholder="$t('total_area')"
                        v-model="forms.total_area"
                        required
                      />
                      <div v-if="errors.total_area">
                        <div
                          v-for="error in errors.total_area"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('pallet_size')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="pallet_size"
                        :placeholder="$t('pallet_size')"
                        v-model="forms.pallet_size"
                        required
                      />
                      <div v-if="errors.pallet_size">
                        <div
                          v-for="error in errors.pallet_size"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('stacking')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="stacking"
                        :placeholder="$t('stacking')"
                        v-model="forms.stacking"
                        required
                      />
                      <div v-if="errors.stacking">
                        <div
                          v-for="error in errors.stacking"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                    <div class="col-lg-2">
                      <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                        $t('max_pallet')
                      }}</label>
                    </div>
                    <div class="col-lg-8">
                      <input
                        type="number"
                        class="form-control"
                        id="max_pallet"
                        :placeholder="$t('max_pallet')"
                        v-model="forms.max_pallet"
                        required
                      />
                      <div v-if="errors.max_pallet">
                        <div
                          v-for="error in errors.max_pallet"
                          :key="error"
                          class="alert alert-primary"
                          role="alert"
                        >
                          <i data-feather="alert-circle"></i>
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('billing_customer_c01')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="billing_customer_c01"
                          :placeholder="$t('billing_customer_c01')"
                          v-model="forms.f01"
                        />
                        <div v-if="errors.f01">
                          <div
                            v-for="error in errors.f01"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                    
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('billing_customer_c02')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="billing_customer_c02"
                          :placeholder="$t('billing_customer_c02')"
                          v-model="forms.f02"
                        />
                        <div v-if="errors.f02">
                          <div
                            v-for="error in errors.f02"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>


                      
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('billing_customer_c03')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="billing_customer_c03"
                          :placeholder="$t('billing_customer_c03')"
                          v-model="forms.f03"
                        />
                        <div v-if="errors.f03">
                          <div
                            v-for="error in errors.f03"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                      
                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                          $t('billing_customer_c04')
                        }}</label>
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="billing_customer_c04"
                          :placeholder="$t('billing_customer_c04')"
                          v-model="forms.f04"
                        />
                        <div v-if="errors.f04">
                          <div
                            v-for="error in errors.f04"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c05')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="billing_customer_c05"
                            :placeholder="$t('billing_customer_c05')"
                            v-model="forms.f05"
                          />
                          <div v-if="errors.f05">
                            <div
                              v-for="error in errors.f05"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
    
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c06')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="billing_customer_c06"
                            :placeholder="$t('billing_customer_c06')"
                            v-model="forms.f06"
                          />
                          <div v-if="errors.f06">
                            <div
                              v-for="error in errors.f06"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c07')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="billing_customer_c07"
                            :placeholder="$t('billing_customer_c07')"
                            v-model="forms.f07"
                          />
                          <div v-if="errors.f07">
                            <div
                              v-for="error in errors.f07"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c08')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="billing_customer_c08"
                            :placeholder="$t('billing_customer_c08')"
                            v-model="forms.f08"
                          />
                          <div v-if="errors.f08">
                            <div
                              v-for="error in errors.f08"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c09')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="billing_customer_c09"
                            :placeholder="$t('billing_customer_c09')"
                            v-model="forms.f09"
                          />
                          <div v-if="errors.f09">
                            <div
                              v-for="error in errors.f09"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>
                   
                      <div class="row mb-3">
                        <div class="col-lg-2">
                          <label for="defaultconfig" class="col-form-label" style="padding-left: 25px">{{
                            $t('billing_customer_c10')
                          }}</label>
                        </div>
                        <div class="col-lg-8">
                          <input
                            type="text"
                            class="form-control"
                            id="billing_customer_c10"
                            :placeholder="$t('billing_customer_c10')"
                            v-model="forms.f10"
                          />
                          <div v-if="errors.f10">
                            <div
                              v-for="error in errors.f10"
                              :key="error"
                              class="alert alert-primary"
                              role="alert"
                            >
                              <i data-feather="alert-circle"></i>
                              {{ error }}
                            </div>
                          </div>
                        </div>
                      </div>

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;
                      <button class="btn btn-primary float-end btn-sm" type="submit">
                           <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "FulfillmentEdit",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      company_type:"",
      permision_role:[],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      fetchCompanyGroup:[],
      company_group:"",
      forms: [],
      userData: "",
      userRole: "",
    };
  },
  watch: {},
  methods: {

    asyncSearchCompanyGroup(){

    const baseURI = this.$settings.endPointBilling + "dashboard/company-group?download=all";

    return this.$http
      .get(
        baseURI,{ timeout: 10000 }
      )
      .then((response) => {
        this.fetchCompanyGroup=response.data.datas;
      }).catch(error => {

        if(error.code == "ECONNABORTED"){
          this.error("Please Check Your Internet Connection");
        }

      });
    },

    
    resetForm() {
      this.forms.company_group        = "";
      this.forms.fulfillment_id       = "";
      this.forms.company_group_id     = "";
      this.forms.fulfillment_code     = "";
      this.forms.fulfillment_description = "";
      this.forms.f01                  = "";
      this.forms.f02                  = "";
      this.forms.f03                  = "";
      this.forms.f04                  = "";
      this.forms.f05                  = "";
      this.forms.f06                  = "";
      this.forms.f07                  = "";
      this.forms.f08                  = "";
      this.forms.f09                  = "";
      this.forms.f10                  = "";
      this.forms.area_palet           = 0;
      this.forms.mover_area           = 0;
      this.forms.total_area           = 0;
      this.forms.pallet_size          = 0;
      this.forms.luas_area_pallet     = 0;
      this.forms.stacking             = 0;
      this.forms.max_pallet           = 0;
    },

    backForm() {
      window.location.href = "/billing-fulfillment";
    },

    loadData(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPointBilling + "dashboard/fulfillment/detail/" + id;
      return this.$http.get(baseURI,{ timeout: 10000 }).then((response) => {
        
        this.isLoading      = false;
        this.forms          = response.data.datas;
        this.company_group  = response.data.datas.company_group
   
      }).catch(error => {
        this.loading();
              
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }

        });
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.userData       = userDatas.sub;
      this.userRole       = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BillingFulfillmentController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_update){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    submitData() {
       this.fade(true);
          this.isLoading = true;
          
          
          if(typeof this.company_group == "object"){
            this.forms.company_group_id = this.company_group.company_group_id
          }else{
            this.forms.company_group_id = ""
          }
 
          const baseURI =
            this.$settings.endPointBilling + "dashboard/fulfillment/update/" + this.forms.fulfillment_id;
          this.$http
            .patch(baseURI, this.forms,{ timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                //this.resetForm();
                this.errors = [];
                this.success(response.data.datas.messages);

                //window.history.back();
                var params = this.$onRandom(this.forms.fulfillment_id);
                 window.location.href = "/billing-fulfillment/detail/" + params + "?status=200&msg=Successfully";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
                this.isLoading = false;
                
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
              //this.resetForm();
            });
    },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
        // onShown: function() {
        //     console.log('asdasdasd');
        //     //window.location.href = '/';
        // }
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    var params = this.$onBehind(this.$route.params.id);
    this.loadData(params[0]);
    this.fetchIt();
  },
};
</script>
<style scoped>
 
</style>